import React, { Component } from "react";
import LoadingBar, { showLoading, hideLoading } from "react-redux-loading-bar";
import { ToastContainer, toast } from "react-toastify";
import { connect } from "react-redux";

import Menu from "Menu/Menu";
//import OffCanvas from "OffCanvas/OffCanvas";
import Footer from "./Footer";
import MediaEditor from "Reveal/MediaEditor/MediaEditor";
//import Lightbox from "Reveal/Lightbox/Lightbox";
//import ImageEditor from "Reveal/ImageEditor/ImageEditor";
//import PDFViewer from "Reveal/PDFViewer/PDFViewer";
import MediaViewer from "Reveal/MediaViewer";
//import VideoViewer from "Reveal/VideoViewer/VideoViewer";
import MaskSelector from "Reveal/MaskSelector/MaskSelector";
import LogoSelector from "Reveal/LogoSelector/LogoSelector";
//import SignInModal from "Reveal/SignInModal/SignInModal";
import AlbumEditor from "../Reveal/AlbumEditor/AlbumEditor";
import DisplayAlbum from "../Reveal/DisplayAlbum";
// import _ from "i18n";

class Layout extends Component {
  componentDidMount() {
    $(document).foundation();
  }

  componentWillUpdate(nextProps, nextState) {
    const { location, dispatch } = nextProps;
    if (location && location.action === "PUSH") {
      dispatch(showLoading());
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { location, dispatch } = this.props;
    if (location && location.action === "PUSH") {
      dispatch(hideLoading());
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.notificationId !== 0 &&
      nextProps.notificationId !== this.props.notificationId
    ) {
      let message = nextProps.message;
      toast.error(<div>{message}</div>);
    }
  }

  render() {
    const { medias } = this.props;
    const ToastCloseBtn = ({ closeToast }) => (
      <span className="toastify__close " onClick={closeToast} />
    );

    return (
      <div className="off-canvas-wrapper">
        {/*<div
          className="off-canvas position-left"
          id="offCanvas"
          data-off-canvas
          data-transition-time="500"
        >
          <OffCanvas />
        </div>*/}
        <div className="off-canvas-content">
          <LoadingBar className="loading-bar" />
          <Menu />
          {this.props.children}
          <Footer />
        </div>
        <div className="mask hide" />

        {/*}<ToastContainer
          position={toast.POSITION.TOP_CENTER}
          hideProgressBar={true}
          closeButton={<ToastCloseBtn />}
          autoClose={5000}
        />
        
        <ImageEditor />
        
        <Lightbox />
        {/*<PDFViewer />
        <VideoViewer /> */}
        <MediaEditor medias={medias} withNav={true} />
        <DisplayAlbum />
        <AlbumEditor />
        <MediaViewer />
        <MaskSelector />
        <LogoSelector />
        {/*}
        <SignInModal />*/}
      </div>
    );
  }
}
const mapStateToProps = state => ({
  medias: state.medias.listing.items
});

export default connect(mapStateToProps)(Layout);



// WEBPACK FOOTER //
// ./src/components/Layout/Layout.js